import type { AccountPreferences } from "@keystone-ui/types";

import { secondsAgo } from "utils";

type LastShownOptions = {
  maxAllowedPrompts: number;
  optInWaitSeconds: number;
};

export function marketingEligible(
  marketingPreference?: AccountPreferences,
  marketingEvent?:
    | string
    | number
    | boolean
    | Record<string, string | number | boolean>,
  lastShownOptions?: LastShownOptions,
): boolean {
  if (marketingPreference?.preferenceValue) {
    return false;
  }
  if (lastShownOptions && marketingEvent?.["presentedAt"]) {
    const lastShown = new Date(marketingEvent?.["presentedAt"]);
    const numSecondsAgo = secondsAgo(lastShown);
    const shownCount = marketingEvent?.["count"] ?? 0;
    return (
      shownCount < lastShownOptions.maxAllowedPrompts &&
      numSecondsAgo >= lastShownOptions.optInWaitSeconds
    );
  }
  return true;
}
